<template>
  <div ref="target" class="dropdown" :class="{'active' : dropdow_visible === true}">
      <div @click="dropdownToggle($event)" class="select" :class="{'dropdown-active' : dropdow_visible === true}">
          <slot name="select" class="active"> </slot>
      </div>

      <div @click="dropdownClose()" v-show="dropdow_visible" class="options">
          <slot name="options"> </slot>
      </div>
  </div>
</template>

<script setup>
import { onMounted, onUnmounted, defineEmits, ref }  from "vue";

const emit = defineEmits([
  'dropdownListOpen', 'dropdownListClose'
])

let dropdow_visible = ref(false);
let target          = ref();

onMounted(() => {
  window.addEventListener('click', onWindowClick)
})

onUnmounted(() => {
  window,removeEventListener('click', onWindowClick);
})

const onWindowClick = (event) => {
  if (target.value.contains(event.target)) {
    return;
  }

  dropdownClose();
}

const dropdownToggle = () => {
  (dropdow_visible.value) ? dropdownClose() : dropdownShow()
}

const dropdownClose = () => {
  dropdow_visible.value = false;
  emit('dropdownListClose');
}

const dropdownShow = () => {
  dropdow_visible.value = true;
  emit('dropdownListOpen');
}
</script>
